import { render } from "./DynamicRenderer.vue?vue&type=template&id=22f3842f"
import script from "./DynamicRenderer.vue?vue&type=script&lang=js"
export * from "./DynamicRenderer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__